import { digitalProducts } from "@constants";
import { applicationSpaRoutes } from "@shared/constants/routes";
import { type IShopifyProduct } from "@types";
import { type TProductType, type TBundleProduct } from "@shared/types/product.types";
import { bundleProducts } from "@shared/constants/bundleProducts";
import { productTypes } from "@shared/constants/productTypes";
import { purchaseTypes } from "@shared/constants/purchaseTypes";
import { type TPurchaseType } from "@shared/types/purchase.types";

const adviceAndReviewPurchaseTypes: TPurchaseType[] = [
  purchaseTypes.digitalDocumentAdvice,
  purchaseTypes.digitalDocumentReview,
];

export const isProductType = (value: string): value is TProductType =>
  [...Object.values(productTypes), ...Object.values(bundleProducts)].some((productType) => productType === value);

export const isDigitalProduct = (productType: TProductType): boolean => digitalProducts.includes(productType);

export const isAdviceOrReviewPurchaseType = (purchaseType: TPurchaseType | null): boolean =>
  purchaseType != null && adviceAndReviewPurchaseTypes.includes(purchaseType);

export const getVariantId = (product?: IShopifyProduct, purchaseType?: TPurchaseType): string | undefined =>
  product?.variants.find((variant) => variant.purchaseType === purchaseType)?.variantId;

export const bundleFlowStartRoutes: Partial<Record<TBundleProduct, string>> = {
  [bundleProducts.package2FuturePow]: applicationSpaRoutes.simpleDocumentCreation.twoFuturePowBundle.generalInformation,
};

export const isBundleProduct = (productType: TProductType): productType is TBundleProduct =>
  Object.values(bundleProducts).includes(productType as TBundleProduct);
